import { CONTENT_LIST_PAGE_ITEM_COUNT } from '@diritto/common/content/constants';
import { ContentProfileRelayResponseDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { useInfiniteQuery } from '@tanstack/react-query';
import { RelayContentApi } from 'api/ApiHelper';
import { contentsQueryKey } from 'queries/contents/queryKey';
import { GetProfileContentsQuery } from '@diritto/common/api/ContentApi';

const getNextPageParam = (lastGroup: ContentProfileRelayResponseDto, allGroups: ContentProfileRelayResponseDto[]) => {
  if ((lastGroup.contentIds?.length ?? 0) < CONTENT_LIST_PAGE_ITEM_COUNT) {
    return undefined;
  }
  return allGroups.reduce((acc, current) => acc + (current.contentIds?.length ?? 0), 0);
};

export const useGetRelayProfileContentsInfiniteQuery = (profileId: number, query: GetProfileContentsQuery) =>
  useInfiniteQuery({
    queryKey: contentsQueryKey.profileContentList(profileId, query),
    queryFn: ({ pageParam = 0 }) =>
      RelayContentApi.getProfileContents(profileId, {
        offset: pageParam,
        limit: CONTENT_LIST_PAGE_ITEM_COUNT,
        ...query,
      }),
    initialPageParam: 0,
    getNextPageParam,
  });
